import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './InvolvedAddressesList.html?raw';
import StaticTable from '../../../moreCore/UI/StaticTable/StaticTable';
import lang from 'dojo/_base/lang';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import EntityStore from '../../../moreCore/Tools/EntityStore';
import { VAM2types } from "../../_loadingHelpers/VAMv2Types";
import InvolvedAddressEditor from './InvolvedAddressEditor/InvolvedAddressEditor';
import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';

class InvolvedAddressesList extends compose(_WidgetBaseSP) {
    templateString: any = template;
    private currentProject: VAM2types.Entity_gDisp;

    private tableContainer: HTMLDivElement;
    private table: MdsLax<InstanceType<typeof StaticTable>>;

    private store: MdsLax<InstanceType<typeof EntityStore<VAM2types.InvolvedAddress>>>;

    private deleteAddress() {

        this.emitDataChanged();
    }

    private _onClickNew() {

        let entityId = this.addNewAddressEntry();
        this._prepareEditor(entityId);
    }
    private addNewAddressEntry(): string {

        let newId = (Math.random() * 100000).toString();
        let newEntry: Partial<VAM2types.InvolvedAddress> = {
            ref_ev_project: this.currentProject,
            ID: newId,
            is_active: true            
        }
        this.store.addEntry(newEntry as any, "new");
        return newId;
    }

    private _onClick_EditBtn(rowGr: StaticTable.StaticTableRowGroup<VAM2types.InvolvedAddress>) {

        let entityId = rowGr.entity.ID;
        this._prepareEditor(entityId);
    }

    private _onTableRowClick(row: StaticTable.StaticTableRow<VAM2types.InvolvedAddress>) {

        let entityId = row.rowGroup.entity.ID;
        this._prepareEditor(entityId);
    }

    private _prepareEditor(entityId: string) {

        this.StandbyStart();
        if (this.store.isEntityNew(entityId)) {

            this.openEditor(entityId);
            return;
        }
        this.RequestManager.callfunction(
            "Webtool_API__ProjectWizard__InvolvedAddresses_GetInvolvedAddressesDataByID",
            { entityId: entityId },
            lang.hitch(this, this.openEditor, entityId),
            (err) => {
                this.showToast(err.Message);
                this.StandbyStop();
            }
        )
    }
    private openEditor(entityId, response?) {
        this.StandbyStop();

        let form = new InvolvedAddressEditor();
        let heading = "";

        form.setProjectId(this.currentProject.ID);

        if (response) {
            form.setData(response);
            heading = response["$Displayname"];
        } else {

            form.setStartupState("ready");
            heading = this.translate(`InvolvedAddress_Heading_AddNew`);
            form.setIsNew(true);
        }

        if (this.store.isEntityChanged(entityId) || this.store.isEntityNew(entityId)) form.applyAllreadyChangedData(this.store.getEntityById(entityId));


        let dlg = new GenericDialog();

        dlg.show(form,
            heading,
            null,
            null,
            "okcancel",
            (result) => {
                if (result === 1) form.externalEventHandler("ok");
                else {
                    if (this.store.isEntityNew(entityId)) {
                        this.store.deleteEntry(entityId);
                    }
                    dlg.close();
                }
            },
            {
                keepOpen: true,
                closeOnEnter: false,                
            });

        form.on("okClicked", (data: { ID: string, changedData: Object }) => {
            
            let existingEntry: VAM2types.InvolvedAddress = null;
            
            if (this.store.isEntityExisting(data.ID, "ID", true)) {

                existingEntry = this.store.getEntityById(data.ID);

                for (let p in data.changedData) {

                    switch (p) {
                        
                        default: 
                            if (data.changedData[p] !== existingEntry[p]) existingEntry[p] = data.changedData[p];
                    }

                }
            }
            console.debug("IA CHANGED DATA", data.changedData, "entry", existingEntry);
            this.store.changeEntry(existingEntry, true);
            this.updateTable();
            dlg.close();

            this.emitDataChanged();
        })
    }

    private emitDataChanged() {

        let data = this.store.getDiffData();

        this.emit("InvolvedAddresses_DataChanged", data);
    }

    private _onClickReload() {
        this._reload();
    }
    private _reload(): void {

        this.StandbyStart();
        this.RequestManager.callfunction(
            "Webtool_API__ProjectWizard__InvolvedAddresses_GetInvolvedAddressesList",
            { projectID: this.currentProject.ID },
            lang.hitch(this, this._onReloadResponse),
            (err) => {
                this.showToast(err.Message);
                this.StandbyStop();
            });
    }
    private _onReloadResponse(response: Array<VAM2types.InvolvedAddress>): void {
        this.StandbyStop();
        this.store.setup(response);
        this.updateTable();
        this.emit("reloaded");
    }

    setData(addressesList): void {

        this.store.setup(addressesList);
    }

    private _setUpTable(response: { layouts: Array<any> }) {
        if (this.table != null) this.table.destroy();

        this.table = new StaticTable();
        this.table.placeAt(this.tableContainer);

        this.table.setLayout(response.layouts[0]);
        this.table.setRowClick(lang.hitch(this, this._onTableRowClick));
        this.table.addDefaultRowActionButton("edit", lang.hitch(this, this._onClick_EditBtn))
        this.table.addDefaultRowActionButton("delete", lang.hitch(this, this.deleteAddress));
        this.table.setCyAttribute("InvolvedAddressesList");
        this.updateTable();
        this.StandbyStop();
    }
    private updateTable() {

        this.table.setupFromStore(this.store);
        //this.emit("InvolvedAddresses_TableUpdate", this.entryList.length > 0);

    //    this.entryList?.forEach(d => {
    //        if (d.toDelete === true) {
    //            this.disableNode(this.table.getRowGroupByKeyValue(d.ID, "ID").rows[0].node);
    //        }
    //    });
    }

    setCurrentProject(project: VAM2types.EvProjectEntity_Extended) {
        this.currentProject = project;
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.store = new EntityStore();

        this.StandbyStart();
        this.RequestManager.callfunction(
            "Webtool_API__ProjectWizard__InvolvedAddresses_GetTableLayout",
            null,
            lang.hitch(this, this._setUpTable),
            (err) => {
                this.showToast(err.Message);
                this.StandbyStop();
            }
        )
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(InvolvedAddressesList);